module.exports = __webpack_public_path__ + "Flag-8.3dd43eb43a5e7a931d815b5123cc08bc.svg";